import * as yup from 'yup'
import { AI_REVIEW_SLP_RATE_MAX, AI_REVIEW_SLP_RATE_MIN } from 'src/constants/ai-review/constants'

export const aiReviewConfigValidator = yup.object({
  stepType: yup.string().required('Step type is required'),
  label: yup.string().trim(),
  instructions: yup.string().trim(),
  // Only meaningful when the explicit-threshold checkbox is ticked; the mappers drop it otherwise.
  //
  // The transform runs in BOTH branches and is what keeps the form submittable: the number input
  // only renders while the checkbox is ticked, so clearing it and then unticking leaves `''` in
  // Formik's state with no field on screen to correct. Without this, `number().notRequired()`
  // casts `''` to NaN and fails the type check on a field the admin cannot even see.
  autoApproveMinSlpRate: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .when('hasAutoApproveMinSlpRate', {
      is: true,
      then: (schema) => {
        return (
          schema
            .typeError('Enter a number')
            // The backend column is an integer. Without this the form accepts 55.6 and
            // `buildSharedFields` silently rounds it to 56 — a value the admin never chose.
            .integer('Enter a whole number')
            .min(AI_REVIEW_SLP_RATE_MIN, `Must be at least ${AI_REVIEW_SLP_RATE_MIN}`)
            .max(AI_REVIEW_SLP_RATE_MAX, `Must be at most ${AI_REVIEW_SLP_RATE_MAX}`)
            .required('Enter a threshold')
        )
      },
      otherwise: (schema) => {
        return schema.notRequired()
      },
    }),
})
